import {Page} from "@indebted/components/Page"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {Trans, useTranslation} from "react-i18next"

export function InitiatedOrSubmittedPage() {
	const {t} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("payment_arrangement_status.initiated_or_submitted.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="left" className="amp-mask">
					<Trans i18nKey="payment_arrangement_status.initiated_or_submitted.message" />
				</Typography>
			</Grid>
		</Page>
	)
}
